




















import {
  Component, Emit, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import VueMultiselect from 'vue-multiselect';

import TransactionParticipantForm from '@/components/TransactionParticipantForm.vue';
import { BankAccount } from '@/api/payment-orders';
import PartyForm from '@/components/PartyForm.vue';

@Component({
  name: 'PartyModal',
  components: {
    PartyForm,
    ValidationProvider,
    ValidationObserver,
    VueMultiselect,
    TransactionParticipantForm,
  },
  inheritAttrs: false,
})
export default class PartyModal extends Vue {
  @Prop({
    type: String,
    default: '',
  })
  readonly title!: string;

  @Prop({
    type: Object,
    default: null,
  })
  readonly party!: Partial<BankAccount> | null;

  @Prop({
    type: Boolean,
  })
  readonly hideIban!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  })
  readonly ibanOptional!: boolean;

  @Prop({
    type: Boolean,
  })
  readonly hideSynesisCode!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  })
  readonly synesisCodeRequired!: boolean;

  @Watch('party', { deep: true, immediate: true })
  onPartyChange(party: Partial<BankAccount> | null) {
    this.party_ = party ?? BankAccount.default();
  }

  party_: Partial<BankAccount> | null = this.party;

  closeModalOnEsc = true;

  isLoading = false;

  get isEdit() {
    return this.party?.id;
  }

  get title_() {
    if (this.title) {
      return this.title;
    }

    return this.isEdit ? 'Uredi stranku' : 'Kreiraj stranku';
  }

  @Emit('submit')
  onSubmit(party: BankAccount) {
    console.log('PartyModal.onSubmit', party);
    return party;
  }

  @Emit('update:visible')
  onClose() {
    return false;
  }
}
